export default __webpack_public_path__ + "static/chicken-tenders-large-ba32b8371838d9125f35d4ca8d859036.jpg";